// extracted by mini-css-extract-plugin
module.exports = {"star1":"rainbowIconStyle_star1__gMjLG","star2":"rainbowIconStyle_star2__bUj2o","star3":"rainbowIconStyle_star3__RahSb","rainbow":"rainbowIconStyle_rainbow__O1FlB"};